<template>
    <div class="filters-card" :class="{'filters-card--grey': greyTheme}">
        <div class="filters-card__top" @click="toggleFilter" :class="openFilter ? 'js-open' : 'js-close'">
            <div class="filters-card__title page-label">Фильтры</div>
        </div>
        <div v-show="openFilter" class="filters-card__cont">
            <div class="filters">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "MainFilter",
    props: {
        greyTheme: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            openFilter: false,
        }
    },
    methods: {
        toggleFilter: function () {
            this.openFilter = !this.openFilter
        }
    }
}
</script>


